<template>
  <b-modal id="give" hide-footer hide-header>
    <give />
  </b-modal>
</template>

<script lang="ts">
import Give from "../Give.vue";

export default {
  components: {
    Give
  }
};
</script>